import { Modal } from "react-bootstrap";
import { X, InfoSquare, Whatsapp, Globe2, Ticket } from "react-bootstrap-icons";
import { useRef, useState } from "react";
import { checkSystemVersion } from "../../store/api/SystemSettingsAPI";
import { useEffect } from "react";
const pkg = require('../../../package.json');

const ModalAboutUs = (props) => {
    const [configData, setConfigData] = useState(null);
    const [appVersion, setAppVersion] = useState([]);
    const companyInfo = JSON.parse(localStorage.getItem("Company"));
    const { show } = props
    useEffect(() => {
        if (show) {
            checkSystemVersion(setAppVersion);
            fetch(process.env.PUBLIC_URL + '/config.json'
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            )
                .then(res => res.json())
                .then(myJson => setConfigData(myJson))
        }

    }, [show])

    return (
        <Modal show={props.show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#838fe8' }}><span><InfoSquare color="white" size={20} />&nbsp;درباره نرم افزار</span><span onClick={() => props.setModalAboutUs(false)} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body style={{ textAlign: "center" }}>
                <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt='' />
                <p style={{ color: "blue", margin: "3px", fontSize: "12px" }}>نسخه نرم افزار: {pkg.version}</p>
                {appVersion && Array.isArray(appVersion) && appVersion.map((item, i) => <p style={{ color: "blue", margin: "3px", fontSize: "12px" }} key={i}>{item}</p>)}
                <div style={{ direction: "ltr" }}>
                    <p style={{ color: "black", fontStyle: "italic" }}><span id="aboutSoftwareWhatsApp" style={{ color: "#227b80" }}></span> <Whatsapp color="green" /></p>
                    <a style={{ fontStyle: "italic", fontSize: "14px", display: "block" }} href={configData?.AboutUsLink ?? "#"}><span id="aboutSoftwareLink"></span><Globe2 /> {configData?.AboutUsLink}</a>
                    <a href={configData?.TICKET_URL ?? "#"} className="tooltipBtn" data-tooltip="تیکت پشتیبانی"
                        style={{ fontSize: "14px", fontStyle: "italic", display: "block", maxWidth:"max-content", margin:"auto" }}
                        target="_blank">
                        <span id="aboutSoftwareWhatsApp" style={{ color: "#227b80" }}></span> <Ticket /> {configData?.TICKET_URL ?? ""}
                    </a>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ direction: "ltr" }}>
            </Modal.Footer>
        </Modal>
    )
}
export default ModalAboutUs;